'use strict';

var createjs = createjs || {};

createjs.StageUtils = class {
	/**
	 * export a stage to an image
	 * @param stage {createjs.Stage} source stage
	 * @param cropRectangle {createjs.Rectangle} crop rectangle, default is uncropped canvas
	 * @param backgroundColor {String} css color value, default is transparent
	 * @param mimeType {String} file format, default is image/png
	 * @returns {String|string}
	 */
	static exportImage(stage, cropRectangle = null, backgroundColor = null, mimeType = null) {
		//use temp canvas to crop image
		let tempCanvas = document.createElement("canvas"),
			tempCtx = tempCanvas.getContext("2d");

		//define cropRectangle if not provided
		if(!cropRectangle) cropRectangle = new createjs.Rectangle(0, 0, stage.canvas.width, stage.canvas.height);

		//set target size
		tempCanvas.width = cropRectangle.width;
		tempCanvas.height = cropRectangle.height;

		//set background color
		if(backgroundColor){
			tempCtx.fillStyle = backgroundColor;
			tempCtx.fillRect(0, 0, cropRectangle.width, cropRectangle.height);
		}

		//copy image
		tempCtx.drawImage(stage.canvas, -cropRectangle.x, -cropRectangle.y);

		return tempCanvas.toDataURL(mimeType||"image/png");
	}

}

